import BackendDeveloperPage from "./BackendDeveloperPage";

export default function PythonDeveloperPage() {
  return <BackendDeveloperPage technology="python" />;
}
